import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import * as moviesCategoryModel from './model'

export function Title(): JSX.Element {
  return <AppTitle t='movies_category' />
}

const skin = era.skin('routes/movies/subcategory')

MovieCategoriesPage.displayName = 'MovieCategoriesPage'
export function MovieCategoriesPage(): JSX.Element {
  const isContentLoading = useUnit(moviesCategoryModel.$contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <Skeleton pageType='grid' isLoading={isContentLoading}>
          <ui.RenderSkin name='vodsCategory' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
